import React from "react";
import SBILogo from "./SBILogo.png";

const Header = (props) => {
  const { partner } = props;
  return (
    <div
      className="header"
      style={{
        boxShadow: "0px 0.5px 8px 2px rgba(0, 0, 0, 0.05)",
        padding: "30px 20px",
        display: "flex",
        marginBottom: 20,
        justifyItems: "center",
        borderWidth: 1,
      }}
    >
      <div
        style={{
          width: "35px",
          height: "35px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <RenderLogo partner={partner} />
      </div>
      <div
        style={{
          // textAlign: "center",
          fontWeight: "500",
          fontSize: "16px",
          // margin : "16px",
          height: "22px",
        }}
      >
        Credit Card Application Form
      </div>
    </div>
  );
};

const RenderLogo = ({ partner }) => {
  let id = partner?.id 
  if (partner) {
    return (
      <img src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/Brand_Logo_PNGs/${id}.png`} style={{ width:70 , height: 35 }} />
    );
  }
  return null;
};

export default Header;
